import { getAuthToken } from '@/lib/trackizy';

/**
 * Fetch the widget display config { enabled, widget: { width, height } }.
 * Returns null on any failure so the widget can fall back to its defaults.
 */
export async function fetchHelpConfig() {
  try {
    const token = getAuthToken();
    const res = await fetch('/api/help-ai/config', {
      headers: token ? { Authorization: `Bearer ${token}` } : {},
    });
    if (!res.ok) return null;
    return await res.json();
  } catch {
    return null;
  }
}

/**
 * POST the conversation and invoke onDelta for each streamed text chunk.
 * Returns when the stream ends. Throws on non-2xx (with the status).
 */
export async function streamHelpChat(messages, onDelta, signal) {
  const token = getAuthToken();
  const res = await fetch('/api/help-ai/chat', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
    },
    body: JSON.stringify({ messages }),
    signal,
  });
  if (!res.ok) {
    const err = new Error(`help-ai ${res.status}`);
    err.status = res.status;
    throw err;
  }
  const reader = res.body.getReader();
  const decoder = new TextDecoder();
  for (;;) {
    const { value, done } = await reader.read();
    if (done) break;
    onDelta(decoder.decode(value, { stream: true }));
  }
}
